<template>
  <div class="relative h-full" :class="{ shimmerElement: item?.shimmer }">
    <CouponTemplate4
      :small="small"
      :code="item.code"
      :discount="item.discount"
      :color="item.color"
      :title="item.title"
      :description="item.description"
      :image="item.image"
      :buttonText="buttonText"
      @useRequested="useCoupon"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { bus } from '@core/events/eventSystem'

const props = defineProps({
  item: {
    type: Object,
    default() {
      return {}
    },
  },
  small: {
    type: Boolean,
    default: false,
  },
  buttonText: {
    type: String,
    default: '',
  },
})

async function useCoupon() {
  // Note: This function is only called when the user explicitly clicks on the coupon button
  // This ensures coupons are only applied by explicit user action, not automatically
  bus.emit('cart_promo_code_apply', {
    code: props.item.code,
    autoApply: true
  })
}
</script>

<style scoped>
.shimmerElement {
  background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  border-radius: 0.5rem;
  padding: 1rem;
}

@keyframes shimmer {
  0% {
    background-position: 200% 0;
  }
  100% {
    background-position: -200% 0;
  }
}
</style>
